module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/akt-6baf95343b680dfb22e93f2332b9c413.png";